import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import FAQItems from "./FAQItems";
import FAQIntro from "./FAQIntro";
import "./FAQs.css";
import { faqs } from "../../../../assets/data/faqs/faqs";











export default function FAQs() {


  const [activeFAQID, setActiveFAQID] = useState<number>(100);
  const handleActiveFAQ = (id: number) => {
    setActiveFAQID(id);
  };

  return (
    <section
      id="faqs"
      className="section faqs"
    >
      <Container>
        <Row>
          <Col
            xs={{ span: 12, order: 1 }}
            md={{ span: 6, order: 1 }}
            lg={{ span: 6, order: 1 }}
            className="d-flex flex-column align-items-start justify-content-center"
          >
            <FAQIntro />
          </Col>
          <Col
            xs={{ span: 12, order: 2 }}
            md={{ span: 6, order: 2 }}
            lg={{ span: 6, order: 2 }}
          >
            {faqs.map((faq, index) => (
              <FAQItems
                key={index}
                id={index}
                question={faq.question}
                answer={faq.answer}
                handleActiveFAQ={handleActiveFAQ}
                activeFAQID={activeFAQID}
                setActiveFAQID={setActiveFAQID}
              />
            ))}
          </Col>
        </Row>
      </Container>
    </section>
  );
}
